// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"41619c2f","150":"0e1cc1da","394":"554c6927","601":"4ea90aef","691":"0c97e78d","742":"3191d0e1","752":"3fff741b","776":"aac560ac","841":"b4a1c52c"}[chunkId] + ".chunk.js";
};